module.exports = __webpack_public_path__ + "static/media/sort.16bfd11b.svg";